import api from '@/services/api';

const state = {
  user: JSON.parse(localStorage.getItem('user') || 'null'),
  token: localStorage.getItem('token') || null,
  isAuthenticated: !!localStorage.getItem('token')
};

const mutations = {
  SET_USER(state, user) {
    state.user = user;
    localStorage.setItem('user', JSON.stringify(user));
  },
  
  SET_TOKEN(state, token) {
    state.token = token;
    state.isAuthenticated = true;
    localStorage.setItem('token', token);
  },
  
  LOGOUT(state) {
    state.user = null;
    state.token = null;
    state.isAuthenticated = false;
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  }
};

const actions = {
  async login({ commit }, credentials) {
    try {
      console.log('🔄 Attempting login...', credentials);
      const response = await api.post('/auth/login', credentials);
      console.log('✅ Login response:', response.data);
      
      const { token, user } = response.data;
      
      commit('SET_TOKEN', token);
      commit('SET_USER', user);
      
      console.log('🔑 Token saved:', token ? token.substring(0, 20) + '...' : 'No token');
      console.log('👤 User saved:', user?.username);
      
      return response.data;
    } catch (error) {
      console.error('❌ Login error:', error);
      throw error.response?.data || error;
    }
  },
  
  logout({ commit }) {
    console.log('🚪 Logging out...');
    commit('LOGOUT');
  },
  
  async checkAuth({ commit, state }) {
    if (!state.token) {
      console.log('❌ No token found for auth check');
      return;
    }
    
    try {
      console.log('🔍 Checking authentication with token:', state.token.substring(0, 20) + '...');
      const response = await api.get('/auth/profile');
      console.log('✅ Auth check successful:', response.data);
      commit('SET_USER', response.data.user);
    } catch (error) {
      console.error('❌ Auth check failed:', error);
      commit('LOGOUT');
      throw error;
    }
  }
};

const getters = {
  currentUser: state => state.user,
  token: state => state.token,
  isAuthenticated: state => state.isAuthenticated,
  hasPermission: state => (permission) => {
    if (!state.user || !state.user.permissions) return false;
    return state.user.permissions.includes(permission);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};